import { BaseSettingsEndpoints } from './base';
import {
  WorkplaceRequestEventsResponse,
  WorkplaceRequestEventsParams
} from '../types/workplace-request-events';

const WORKPLACE_REQUEST_EVENTS_BASE_PATH = '/v1/tickets';

export class WorkplaceRequestEventsClient extends BaseSettingsEndpoints {
  async getWorkplaceRequestEvents(
    ticketId: string,
    params: WorkplaceRequestEventsParams = {}
  ) {
    const { cursor, limit = 50, tz = 'UTC' } = params;
    const queryParams = new URLSearchParams();
    
    if (cursor) {
      queryParams.set('cursor', cursor);
    }
    if (limit) {
      queryParams.set('limit', limit.toString());
    }
    if (tz) {
      queryParams.set('tz', tz);
    }
    
    const queryString = queryParams.toString();
    const url = `${WORKPLACE_REQUEST_EVENTS_BASE_PATH}/${ticketId}/events${queryString ? `?${queryString}` : ''}`;
    
    return this.get<WorkplaceRequestEventsResponse>(url);
  }
}
